<template>
  <vue3-pull-to-refresh
    :distance="distance"
    noreload
    @onrefresh="handleRefresh"
  />
  <!-- Remount slot subtree to 'soft refresh' the view without page reload -->
  <div :key="refreshKey">
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import Vue3PullToRefresh from '@amirafa/vue3-pull-to-refresh'

// Props to define pull-to-refresh distance
const { distance = 50 } = defineProps<{ distance?: number }>()

//   Soft refresh (remount slot)
const refreshKey = ref(0)

// Function to handle refresh
function handleRefresh() {
  console.groupCollapsed('🔄 PullDownRefresh — Remount Slot (SOFT)')
  console.time('component-remount')
  refreshKey.value++      // forces <slot/> subtree (e.g., <RouterView/>) to remount
  console.timeEnd('component-remount')
  console.groupEnd()
}
</script>

<style lang="scss">
// Size/stacking of the pull-to-refresh icon
.icon-container.transition-all {
  z-index: 999 !important;
  width: 38px !important;
  height: 38px !important;
  // transform: translateY(200%) !important; // Uncomment to view on page to edit
}

// Force icon color over inline fill
.icon-container svg path {
  fill: rgba(var(--v-theme-primary)) !important;
}
</style>